export default "__VITE_ASSET__Y1fPQFZs__"